import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddOnCategory } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindAddOnCategory, GetAddOnCategory } from "../../addonCategory/api/interface";

export const findSelectAddOnCategory = createAsyncThunk(
  "selectAddOnCategory/findSelectAddOnCategory",
  async (values: FindAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectAddOnCategory = createAsyncThunk(
  "selectAddOnCategory/searchSelectAddOnCategory",
  async (values: FindAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectAddOnCategory = createAsyncThunk(
  'selectAddOnCategory/getSelectAddOnCategory',
  async ({ id }: GetAddOnCategory, { rejectWithValue }) => {
    try {
      const response = await AddOnCategory.get(id, {});

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
